import { Checkbox } from '../../../components'

interface ToogleHifiProps {
  handleToggleHifi: () => void
  isPro: boolean
}

export const ToogleHifi: React.FC<ToogleHifiProps> = ({
  handleToggleHifi,
  isPro
}) => {
  return (
    <div
      className="flex items-center justify-end flex-row"
      onClick={handleToggleHifi}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleToggleHifi()
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="flex items-center">
        <div className="flex gap-[10px]">
          <img src="/assets/images/icon-hifi.svg" alt="hifi" />
          <img src="/assets/images/hifi.svg" alt="hifi" />
        </div>
      </div>
      {!isPro ? <Checkbox onChange={() => {}} /> : null}
    </div>
  )
}
